// extracted by mini-css-extract-plugin
export default {"container":"_1Ux1ru3","wrapper":"_1Ito59o"};